
import {Component, Vue} from "vue-property-decorator";
import ContentPageLayout from "@/components/UI/renewal/ContentPageLayout.vue";
import RecruitContent from "@/components/recruit/RecruitContent.vue";

@Component({
  components: {
    ContentPageLayout,
    RecruitContent,
  },
})
export default class Recruit extends Vue {
}
